import I18n from "components/materials/I18n";
import useHead from "hooks/useHead";
import { ESubStep } from "common/enums/Subscription/ESubStep";
import SubscriptionsTable from "../elements/SubscriptionsTable";

export default function ToProcess() {
	useHead({
		title: `${I18n.asset.pages.mo_subscriptions.page_title} - ${I18n.asset.pages.mo_subscriptions.sub_pages.to_process.page_title}`,
	});

	return <SubscriptionsTable subSteps={[ESubStep.processing]} dateLabel={I18n.asset.pages.mo_subscriptions.sub_pages.to_process.date} />;
}
